(function () {
  function initAnnouncementBar(section) {
    if (!section) return;
    if (section.dataset.announcementInitialized === 'true') return;

    section.dataset.announcementInitialized = 'true';

    const rotator = section.querySelector('[data-announcement-rotator]');
    if (!rotator) return;

    const texts = rotator.querySelectorAll('.announcement-text');
    if (!texts.length) return;

    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const rotationEnabled = isMobile
      ? true
      : rotator.dataset.rotationDesktop === 'true';

    texts.forEach((text, index) => {
      text.classList.remove('active', 'exit');
      text.style.opacity = '';
      text.style.visibility = '';
      text.style.transform = '';
      text.style.pointerEvents = '';

      if (index === 0) {
        text.classList.add('active');
      }
    });

    if (texts.length < 2 || !rotationEnabled) return;

    const rotationSpeed = parseInt(rotator.dataset.rotationSpeed || '4000', 10);
    let current = 0;

    window.setInterval(() => {
      const next = (current + 1) % texts.length;

      texts[current].classList.remove('active');
      texts[current].classList.add('exit');

      texts[next].classList.remove('exit');
      texts[next].classList.add('active');

      current = next;
    }, rotationSpeed);
  }

  function initAllAnnouncementBars(scope) {
    const container = scope || document;
    const sections = container.querySelectorAll('[id^="announcement-section-"]');
    sections.forEach(initAnnouncementBar);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllAnnouncementBars(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      initAllAnnouncementBars(event.target);
    }
  });
})();